export default {
    namespaced: true,
    state: {
        errors: [],
    },
    getters: {
        listErrors(state) {
            return state.errors;
        },
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        CLEAR(state) {
            state.errors = [];
        },
        ADD(state, data) {
            state.errors.push(data);
        },
    },
    actions: {
    },
};




// WEBPACK FOOTER //
// ./src/store/errors.js